import { AboutTemplate } from '@fontbold/ui';
import { createFileRoute } from '@tanstack/react-router';
import { AppTabBar, AppTopBar } from '#/components/AppChrome';
import { AppNewsletter, openNewsletter } from '#/components/AppNewsletter';
import { pageTitle, socialLinks } from '#/lib/site';
import { getSpace } from '#/lib/space-fn';
import { DEFAULT_LOGO, spaceLogo } from '#/lib/space-logo';

export const Route = createFileRoute('/over')({
  head: ({ loaderData }) => ({
    meta: [{ title: pageTitle('Over', loaderData?.space) }],
  }),
  loader: async () => {
    const space = await getSpace();
    return { space };
  },
  component: AboutPage,
});

function AboutPage() {
  const { space } = Route.useLoaderData();
  if (!space) return null;

  const logo = spaceLogo(space);
  const heroImage = space.about?.heroImage?.url ?? DEFAULT_LOGO;
  const storyImage = space.about?.storyImage?.url ?? DEFAULT_LOGO;
  const socialImage = space.about?.socialImage?.url ?? DEFAULT_LOGO;

  return (
    <>
      <AboutTemplate
        topBar={
          <AppTopBar
            space={space}
            active="over"
            onNewsletter={openNewsletter}
          />
        }
        tabBar={<AppTabBar space={space} active="over" />}
        hero={{
          image: heroImage,
          imageAlt: `Nana Asare van ${space.name}`,
          eyebrow: 'Over',
          title: space.name,
          tagline: 'Culturen, verhalen en smaken komen samen.',
          logo,
        }}
        story={{
          intro: {
            paragraphs: [
              <>
                <strong>{space.name}</strong> is een platform waar culturen,
                verhalen en smaken samenkomen. Op zijn zoektocht naar lokale,
                authentieke en legendarische eetplekken neemt host Nana zijn
                volgers op Instagram, TikTok en YouTube mee om bekende parels te
                (her)ontdekken, nieuwe ondernemers te leren kennen en cultureel
                gewaardeerde gerechten van over de hele wereld te proeven.
              </>,
              'Waar de meeste content creators zich richten op hypes, zet Nana juist de spotlight op zaken en ondernemers die al jarenlang bestaan.',
            ],
            pullQuote: 'F*ck de hype, ga voor authenticiteit.',
          },
          spot: {
            eyebrow: 'Wat zijn ze',
            title: 'OG Foodspots',
            body: 'OG Foodspots zijn plekken die worden gerespecteerd in de buurt en er vaak al jaren zitten. Vaak familiebedrijven, waar je de passie echt terug proeft in het eten. Maar het is meer dan een foodspot. Het is een plek waar de community samenkomt, waar connecties ontstaan en verhalen worden gedeeld. Juist omdat deze plekken onder druk staan door gentrificatie, hoge kosten en concurrentie, is het belangrijk om ze te blijven pushen.',
            image: storyImage,
            imageAlt: 'Nana op bezoek bij Hayran Shoarma',
          },
          content: {
            title: 'Check mijn content',
            body: `Volg ${space.name} voor nieuwe plekken, verhalen en video's achter de gerechten.`,
            image: socialImage,
            imageAlt: `${space.name}-content achter de schermen`,
            socialLinks: socialLinks(space),
            onNewsletter: openNewsletter,
          },
          contact: space.contactEmail
            ? { label: 'Samenwerken?', email: space.contactEmail }
            : undefined,
          copyright: `(c) ${new Date().getFullYear()} ${space.name}`,
        }}
      />
      <AppNewsletter spaceId={space.id} logo={logo} />
    </>
  );
}
